import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  bairros: [],
};

const getters = {
  // Bairro
  bairros: state => state.bairros.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  bairrosAtivo: state => state.bairros.filter(b => b.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Bairro
  async fetchBairros({ commit }) {
    const response = await axios.get(`${baseUrl}/bairros`);
    if (response.data) {
      commit('setBairros', response.data);
    } else {
      commit('setBairros', []);
    }
  },
  async fetchBairrosSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/bairros?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setBairros', response.data);
      } else {
        commit('setBairros', []);
      }
    } catch (error) {
      commit('setBairros', []);
    }
  },
  async addBairro({ commit }, bairro) {
    const response = await axios.post(`${baseUrl}/bairros`, bairro, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    bairro.IdBairro = response.data.IdBairro;
    commit('newBairro', bairro);
    return response.data.IdBairro;
  },
  async updateBairro({ commit }, updBairro) {
    await axios.put(`${baseUrl}/bairros`, updBairro, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateBairro', updBairro);
  },
  async deleteBairro({ commit }, id) {
    await axios.delete(`${baseUrl}/bairros/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeBairro', id);
  },
}

const mutations = {
  // Bairro
  setBairros: (state, bairros) => state.bairros = bairros,
  newBairro: (state, bairro) => state.bairros.push(bairro),
  removeBairro: (state, id) => state.bairros = state.bairros.filter(bairro => bairro.IdBairro !== id),
  updateBairro: (state, updBairro) => {
    const index = state.bairros.findIndex(bairro => bairro.IdBairro === updBairro.IdBairro);
    if (index !== -1) {
      state.bairros.splice(index, 1, updBairro);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}